'use client';

import { CommonEventsEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/common/commonEventsEnum';
import { EventsEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/pdfGenius/eventsEnum';
import Cookies from 'js-cookie';

import { getGoogleAnalyticsClientId } from '@/lib/analytics/hooks/client-id';
import { getCurrentUrl } from '@/lib/analytics/hooks/route-change';
import { reportDownloadSuccess } from '@/lib/analytics/services/download-success-report';
import { trackReviewHappyMoment } from '@/features/review-flow/services/happy-moment';
import { sendHubxEventPayload } from '@/lib/analytics/services/send-hubx-event';
import {
  buildHubxPayload,
  type LogHubxEventParams,
} from '@/lib/analytics/services/log-hubx-event-adapter';
import {
  processEventQueue,
  queueHubxEvent,
} from '@/lib/analytics/services/log-hubx-event-queue';
import { getUtmParams } from '@/lib/analytics/utils/get-utm-params';
import { store } from '@/store';
import { selectAuth } from '@/store/slices/authSlice';

export function logHubxEvent(params: LogHubxEventParams): void {
  const currentUrl = getCurrentUrl();
  const eventName = params.eventName;
  const clientId = getGoogleAnalyticsClientId();
  const auth = selectAuth(store.getState());
  const utmParams = getUtmParams();
  const firstVisit = Cookies.get('first_visit_timestamp');
  const firstVisitTimestamp = firstVisit ?? new Date().toISOString();

  reportDownloadSuccess({
    eventName,
    params,
    auth,
    clientId,
    currentUrl,
    isPlanActive: store.getState().plan.isActive,
  });

  // Review flow: detect happy moment (download success) from one central point.
  trackReviewHappyMoment({ eventName, params });

  if (!clientId) {
    queueHubxEvent({
      params,
      currentUrl,
      firstVisitTimestamp,
      eventTimestamp: params.event_timestamp ?? new Date().toISOString(),
      auth,
      utmParams,
    });
    void processEventQueue();
    return;
  }

  if (
    firstVisit === undefined &&
    eventName !== CommonEventsEnum.CUSTOM_FIRST_VISIT
  ) {
    Cookies.set('first_visit_timestamp', firstVisitTimestamp, {
      expires: 365,
      sameSite: 'Lax' as const,
      secure: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production',
    });
    logHubxEvent({
      eventName: CommonEventsEnum.CUSTOM_FIRST_VISIT,
    });
  }

  void sendHubxEventPayload(
    buildHubxPayload(
      params,
      auth,
      utmParams,
      currentUrl,
      firstVisitTimestamp,
      new Date().toISOString(),
      clientId
    )
  );
}

export { processEventQueue };
export const COMMON_EVENTS = CommonEventsEnum;
export const APP_EVENTS = EventsEnum;
